@if (dataLoaded) {
  <div class="row">
    <rask-input
      class="col-2"
      label="Inmätningshandelssortiment"
      [(ngModel)]="searchModel.inmatningshandelssortiment"
      aid="InmatningshandelssortimentRegelverkFilter">
    </rask-input>
    <rask-tree-selector
      class="col-2"
      label="Mo/Ro/Po"
      [items]="searchFilterVerksamhetsOmraden"
      [comparePredicate]="comparePredicate"
      aid="OmradeAffarsledRegelverkFilter">
    </rask-tree-selector>
    <rask-button
      class="col-4"
      color="secondary"
      aid="filtreraRegelverkviol3"
      (click)="search()">Sök
    </rask-button>
  </div>
}
<div class="row">
  @if (searchResult) {
    <rask-matinfo class="col-12" [searchResult]="searchResult">
    </rask-matinfo>
  }
</div>

